var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLayout',{class:_vm.coordinates? 'baselayout-card-body-no-padding' : ''},[(!_vm.coordinates)?_c('div',[_c('h4',[_vm._v("Onde me conectar")]),_c('p',[_vm._v("Localize os pontos de WIFI proximos a você pra")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.getLocation}},[_vm._v("Ativar localização")])],1):_c('div',[_c('GmapMap',{staticClass:"places-map",attrs:{"options":{
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
        },"center":{lat:_vm.coordinates.lat, lng:_vm.coordinates.lng},"zoom":15,"map-type-id":"terrain"}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }